import React, { Component, ErrorInfo, ReactNode } from "react";
import { CriticalErrorPage } from "./CriticalErrorPage";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    console.error("Critical error caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <CriticalErrorPage
          error={this.state.error ?? undefined}
          errorInfo={this.state.errorInfo ?? undefined}
          clearError={() => {
            this.setState({ hasError: false, error: null, errorInfo: null });
          }}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
